import { FC, PropsWithChildren } from 'react';

import { createGenericContext } from '@adflow/utils';
import { CreativeHubTypes } from '@adflow/graphqlgen';

type APIClientContext = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listAdvertisers: () => Promise<Array<any>>;
  getBrandsByAdvertiser: (advertiserId: number) => Promise<CreativeHubTypes.Brand[]>;
  getBrandById: (brandId: string) => Promise<CreativeHubTypes.Brand | null>;
};

const [useAPIClient, APIClientContextProvider] = createGenericContext<APIClientContext | null>();

const Provider: FC<PropsWithChildren<APIClientContext>> = ({ children, ...value }) => {
  return <APIClientContextProvider value={value}>{children}</APIClientContextProvider>;
};

export { Provider, useAPIClient };
export type { APIClientContext as APIClient };
